export const UPLOAD_TYPE = 'FileUpload';
export const DOWNLOAD_TYPE = 'FileDownload';
export const CHANGE_TYPE = 'TailSpendUpdate';
export const UPLOAD_STATUS = {
	NO_DATA: 1,
	UPLOADED: 2,
	VALIDATED: 4,
	CLASSIFYING: 6,
	CLASSIFIED: 8,
	PUBLISHED: 16,
	FAILED: 32,
};

export const DIRECT_TAXONOMY_STATUS = {
	NOT_STARTED: 1,
	IN_PROGRESS: 2,
	COMPLETED: 4,
	FAILED: 8,
};

export const FILE_TYPES = {
	TRANSACTIONS: 2,
	UNCLASSIFIED_INDIRECT: 4,
	UNCLASSIFIED_DIRECT: 5,
};

export const SPEND_TYPE = {
	DIRECT: 'direct',
	INDIRECT: 'indirect',
};

export const SPEND_PARAM = {
	DIRECT: 0,
	INDIRECT: 1,
};

export const VENDOR_UPLOAD_STATUS = {
	UNEXCEPTED_ERROR: 0,
	NO_DATA: 1,
	UPLOADING: 2,
	UPLOADFAILED: 3,
	UPLOADED: 4,
	VALIDTING: 5,
	VALIDATIONFAILED: 6,
	VALIDATED: 7,
	FILEFORMATERROR: 8,
	ILLEGALCHARACTERERROR: 9,
	TRANSLATING: 10,
	TRANSLATIONFAILED: 11,
	TRANSLATED: 12,
	PREPROCESSINGFAILED: 13,
	DEDUPPING: 14,
	DEDUPFAILED: 15,
	DEDUPPED: 16,
	FILEGENERATED: 17,
	FILEGENERATIONFAILED: 18,
	PUBLISHING: 19,
	PUBLISHFAILED: 20,
	PUBLISHED: 21,
};

export const CATEGORY_UPLOAD_STATUS = {
	NO_DATA: 1,
	UPLOADING: 2,
	UPLOADED: 3,
	VALIDTING: 4,
	VALIDATED: 5,
	PIPELINESTARTING: 6,
	DATACOPY: 7,
	DATATRANSFORMATION: 8,
	DATATRANSFORMED: 9,
	DATAPUBLISHED: 10,
	ERRORSTATE: 99,
	CATEGORYDATAUPLOADFAILED: 90,
	CATEGORYDATAVALIDATIONFAILED: 91,
};

export const SKU_UPLOAD_STATUS = {
	NO_DATA: 1,
	UPLOADING: 2,
	UPLOADED: 3,
	VALIDTING: 4,
	VALIDATED: 5,
	PIPELINESTARTING: 6,
	DATACOPY: 7,
	DATAPUBLISHED: 8,
	SKUDATAUPLOADFAILED: 90,
	ERRORSTATE: 99,
	SKUDATAVALIDATIONFAILED: 91,
};

// Instructions to upload files for Self Serve ETL - Column Mapping
export const UploadInstructions = [
	'Only *XLSX* and *CSV* files are accepted in the current phase of self-serve data upload.',
	'Data should be available from the *first row* and *first column (i.e. A1 cell)*.',
	'Data processing time will *depend* on the *number* of files and *size* of the files.',
	'After initial data upload, user will receive *log* of *data error* (if there are any errors). User can choose to *handle exceptions* or *bypass* them and classify the rest of the data.',
	// 'User will be provided with an indication of the *approximate time* required for publication of the spend cube after initial data upload.',
	'At every stage of the process, the user will receive an *email notification* with a status update.',
	'User will have to select whether the uploaded files are for *direct* or *indirect*.',
	// 'Duplicate file names should not be entered.',
	// 'Please ensure that the column headers should be separated by *underscore(_)* and not by any other character or space.',
	'The files should not contain *duplicate column names*. In case of duplicate columns, *only the first* column will be considered.',
	// 'Column Mapping must be completed within *48 hours*.',
	'To enable the *SKU module*, the user must provide details for the following columns (as per the relevant mapping):',
	{
		cols: [
			'SKU ID',
			'SKU Description',
			'Commodity Code',
			'Commodity Description',
			'Commodity Family',
			'Unit Price',
			'SKU Volume / Quantity',
		],
	},
	'To enable the *Working Capital module*, the user must provide details for the following columns (as per the relevant mapping):',
	{
		cols: [
			'Payment Date',
			'Receive Date',
			'Invoice Date (Working Capital)',
			'Invoice Number',
			'Site',
		],
	},
];

export const VIEW_OPTIONS = {
	dataPriview: 0,
	mapping: 1,
};

export const VIEW_OPTIONS_Label = {
	0: 'Data Preview',
	1: 'Mapping',
};

export const ETL_PROCESS_STATUS = {
	NO_DATA: 1,
	DATA_UPLOADING: 2,
	DATA_UPLOADED: 3,
	EXTRACTING_HEADERS: 4,
	MAPPING_STARTED: 5,
	UNCLASSIFIED_FILE_GENERATING: 6,
	UNCLASSIFIED_FILE_GENERATED: 7,
	NORMALIZATION_IN_PROGRESS: 8,
	NORMALIZATION_SUCCEEDED: 9,
	CLASSIFICATION_IN_PROGRESS: 10,
	CLASSIFICATION_SUCCEEDED: 11,
	UPLOAD_FAILED: 12,
	COLUMN_EXTRACTION_FAILED: 13,
	UNCLASSIFIED_FILE_GENERATION_FAILED: 14,
};

//prefedined columns for ETL Self Serve Process
export const predefinedColumns = [
	{
		columnName: 'VENDOR_NAME',
		displayName: 'Supplier Name',
		required: true,
		description: 'Supplier name or vendor name.',
	},
	{
		columnName: 'PO_CURRENCY_BASE_VALUE',
		displayName: 'Spend',
		required: true,
		description: 'Spend or total amount.',
	},
	{
		columnName: 'PARENT_LEGAL_ENTITY',
		displayName: 'Client Name',
		required: true,
		description:
			'Enter client name, if client name is missing from data file. If the client name is not known, select “Other” and enter the name manually in the text box.',
	},
	{
		columnName: 'PURCHASING_LEGAL_ENTITY',
		displayName: 'Portcos',
		required: true,
		description:
			'If client has multiple portcos, please use column for providing the information',
	},
	{
		columnName: 'PO_CREATION_DATE',
		displayName: 'Invoice Date',
		required: false,
		description:
			'Invoice date of the spend. If the invoice date is not available, then the system will automatically use the start date of the current year as default',
	},
	{
		columnName: 'PO_CURRENCY_BASE',
		displayName: 'Spend Currency',
		required: false,
		description: 'Currency of the spend/total amount.',
	},
	{
		columnName: 'DPO',
		displayName: 'DPO Days',
		required: false,
		description:
			'DPO days data (if available). Note - data should be round integers, and not text',
	},
	{
		columnName: 'CUSTOM_L1CATEGORY',
		displayName: 'Client Taxonomy L1',
		required: false,
		description:
			'Client taxonomy L1 (if spend data file contains the information)',
	},
	{
		columnName: 'CUSTOM_L2CATEGORY',
		displayName: 'Client Taxonomy L2',
		required: false,
		description:
			'Client taxonomy L2 (if spend data file contains the information)',
	},
	{
		columnName: 'CUSTOM_L3CATEGORY',
		displayName: 'Client Taxonomy L3',
		required: false,
		description:
			'Client taxonomy L3 (if spend data file contains the information)',
	},
	{
		columnName: 'CUSTOM_L4CATEGORY',
		displayName: 'Client Taxonomy L4',
		required: false,
		description:
			'Client taxonomy L4 (if spend data file contains the information)',
	},
	{
		columnName: 'PURCHASING_LOCATION',
		displayName: 'Purchasing Location',
		required: false,
		description:
			'Purchasing location country (this is typically vendor country)',
	},
	{
		columnName: 'RECEIVING_LOCATION',
		displayName: 'Receiving Location',
		required: false,
		description:
			'Receiving location country (this is typically client site country)',
	},
	{
		columnName: 'PURCHASING_GROUP',
		displayName: 'Business Unit',
		required: false,
		description:
			'Business unit of the company. If business unit data is not available, leave it blank',
	},
	{
		columnName: 'PO_GL_CODE',
		displayName: 'GL Description',
		required: false,
		description:
			'GL description (if spend data file contains the information).',
	},
	{
		columnName: 'PO_COST_CENTRE',
		displayName: 'Cost Center',
		required: false,
		description:
			'Cost Center description (if spend data file contains the information).',
	},
	{
		columnName: 'SKU',
		displayName: 'SKU ID',
		required: false,
		description: 'SKU ID information.',
	},
	{
		columnName: 'SKU_Description',
		displayName: 'SKU Description',
		required: false,
		description: 'SKU description information.',
	},
	{
		columnName: 'Commodity_Code',
		displayName: 'Commodity Code',
		required: false,
		description: 'Commodity code information.',
	},
	{
		columnName: 'Commodity_Description',
		displayName: 'Commodity Description.',
		required: false,
		description: 'Commodity description information.',
	},
	{
		columnName: 'Commodity_Family',
		displayName: 'Commodity Family',
		required: false,
		description: 'Commodity family information.',
	},
	{
		columnName: 'Unit_Price_USD',
		displayName: 'Unit Price',
		required: false,
		description:
			'Unit price for SKU data. Currency for this must match the spend currency.',
	},
	{
		columnName: 'Volume',
		displayName: 'SKU Volume/Quantity',
		required: false,
		description: 'Volume information for SKU data.',
	},
	// below are the columns for working capital. If any one of the columns is selected,
	// all the other columns related to working capital must also be mapped.
	{
		columnName: 'Payment_Date',
		displayName: 'Payment Date',
		required: false,
		description:
			'Payment date - this is used for Working Capital calculations.',
	},
	{
		columnName: 'Receive_Date',
		displayName: 'Receive Date',
		required: false,
		description:
			'Receive Date - this is used for Working Capital calculations.',
	},
	{
		columnName: 'Invoice_Date',
		displayName: 'Invoice Date Working Capital',
		required: false,
		description:
			'Invoice Date - this is used for Working Capital calculations.',
	},
	{
		columnName: 'Invoice_Number',
		displayName: 'Invoice Number',
		required: false,
		description:
			'Invoice number - this is used for Working Capital calculations.',
	},
	{
		columnName: 'site',
		displayName: 'Site',
		required: false,
		description: 'Site - this is used for Working Capital calculations.',
	},
];

export const MAX_CUSTOM_COLUMNS = 40;

export const workingCapitalCols = [
	'Payment_Date',
	'Receive_Date',
	'Invoice_Date',
	'Invoice_Number',
	'site',
];
